export default __webpack_public_path__ + "ffe59deadc96a77fc0e5760bcf6c4bea.png";